// This file was autogenerated from /frontend/sail-next/packages/docs/src/component-examples/FormFieldGroup/layout.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { Switch, FormFieldGroup } from '@sail/ui';
export const Layout = () => <FormFieldGroup legend="Spiffy settings" layout="column">
    <Switch label="Enable transmogrifier" description="Scientific progress goes 'boink'" />
    <Switch label="Set zorcher on 'shake and bake'" description="Note: blasters may be useless against slime" />
  </FormFieldGroup>;